import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location)
}
const menuLists =  JSON.parse(localStorage.getItem('ToMenuitems'))
const toPath = localStorage.getItem('toPath') 
let paths = 'login',title = '登录';
paths = toPath?toPath:'parkList'
const commonRoutes = [
    {
        path: '/login',
        name: 'login',
        meta: { title: '登录' },
        component: () => import('../components/Login.vue'),
    },
    {
        path: '/404',
        name: '404',
        meta: { title: '404' },
        component: () => import('../components/404.vue'),
    },
    {
        path: '/menuList',
        name: 'menuList',
        meta: { title: '菜单列表' },
        component: () => import('../views/system/menuList.vue'),
    },
    {
        path: '/',
        name: paths,
        meta: { title },
        redirect: '/' + paths
    },
]
// 本地所有的页面 需要配合后台返回的数据生成页面
export const asyncRoutes = {
    // 数据看板-总
    Home: {
        path: 'Home',
        name: 'Home',
        meta: { title: '数据看板-总' },
        component: () => import('../views/Home.vue'),
    },   
    // 数据看板-小区
    Home_b: {
        path: 'Home_b',
        name: 'Home_b',
        meta: { title: '数据看板-小区' },
        component: () => import('../views/Home_b.vue'),
    },      
    // 系统管理
    userList: {
        path: 'userList',
        name: 'userList',
        meta: { title: '平台用户列表' },
        component: () => import('../views/system/userList.vue'),
    },
    characterList: {
        path: 'characterList',
        name: 'characterList',
        meta: { title: '角色管理' },
        component: () => import('../views/system/characterList.vue'),
    },
    menuList: {
        path: 'menuList',
        name: 'menuList',
        meta: { title: '菜单管理' },
        component: () => import('../views/system/menuList.vue'),
    },

    tenant: {
        path: 'tenant',
        name: 'tenant',
        meta: { title: '租户管理' },
        component: () => import('../views/system/tenant.vue'),
    },
    // 小区管理
    parkList: {
        path: 'parkList',
        name: 'parkList',
        meta: { title: '小区管理' },
        component: () => import('../views/park/parkList.vue'),
    },
    // 小区类型
    parkType: {
        path: 'parkType',
        name: 'parkType',
        meta: { title: '小区类型' },
        component: () => import('../views/park/parkType.vue'),
    },    
    // 物业人员分类
    personnelClass: {
        path: 'personnelClass',
        name: 'personnelClass',
        meta: { title: '物业人员分类' },
        component: () => import('../views/personList/personnelClass.vue'),
    },
    // 人员列表
    personList: {
        path: 'personList',
        name: 'personList',
        meta: { title: '用户列表' },
        component: () => import('../views/personList/personList.vue'),
    },   
    // 人员列表
    userExamine: {
        path: 'userExamine',
        name: 'userExamine',
        meta: { title: '用户审核管理' },
        component: () => import('../views/personList/userExamine.vue'),
    },       
    // 房屋管理
    house: {
        path: 'house',
        name: 'house',
        meta: { title: '楼栋列表' },
        component: () => import('../views/house/house.vue'),
    },
    unit: {
        path: 'unit',
        name: 'unit',
        meta: { title: '单元列表' },
        component: () => import('../views/house/unit.vue'),
    },
    floor: {
        path: 'floor',
        name: 'floor',
        meta: { title: '楼层列表' },
        component: () => import('../views/house/floor.vue'),
    },
    room: {
        path: 'room',
        name: 'room',
        meta: { title: '房间列表' },
        component: () => import('../views/house/room.vue'),
    },
    //一物一码
    thingYard: {
        path: 'thingYard',
        name: 'thingYard',
        meta: { title: '设备列表' },
        component: () => import('../views/thingYard/thingYard.vue'),
    },
    thingClass: {
        path: 'thingClass',
        name: 'thingClass',
        meta: { title: '分类列表' },
        component: () => import('../views/thingYard/thingClass.vue'),
    },
    //访客列表
    visitor: {
        path: 'visitor',
        name: 'visitor',
        meta: { title: '访客列表' },
        component: () => import('../views/visitor/visitor.vue'),
    },
    accessControl: {
        path: 'accessControl',
        name: 'accessControl',
        meta: { title: '访客登记' },
        component: () => import('../views/visitor/accessControl.vue'),
    },    
    // 缴费管理
    payRecordClass: {
        path: 'payRecordClass',
        name: 'payRecordClass',
        meta: { title: '缴费类型' },
        component: () => import('../views/payRecord/payRecordClass.vue'),
    },
    payRecordList: {
        path: 'payRecordList',
        name: 'payRecordList',
        meta: { title: '缴费列表' },
        component: () => import('../views/payRecord/payRecordList.vue'),
    },
    payRecordNoList: {
        path: 'payRecordNoList',
        name: 'payRecordNoList',
        meta: { title: '未缴费列表' },
        component: () => import('../views/payRecord/payRecordNoList.vue'),
    },  
    templateList: {
        path: 'templateList',
        name: 'templateList',
        meta: { title: '缴费模板管理' },
        component: () => import('../views/payRecord/templateList.vue'),
    },  
    templateTypeList: {
        path: 'templateTypeList',
        name: 'templateTypeList',
        meta: { title: '缴费模板类型' },
        component: () => import('../views/payRecord/templateTypeList.vue'),
    },    
    dailyReport: {
        path: 'dailyReport',
        name: 'dailyReport',
        meta: { title: '资金日报表' },
        component: () => import('../views/payRecord/dailyReport.vue'),
    },  
    monthlyReport: {
        path: 'monthlyReport',
        name: 'monthlyReport',
        meta: { title: '资金月报表' },
        component: () => import('../views/payRecord/monthlyReport.vue'),
    },   
    provisionalBill: {
        path: 'provisionalBill',
        name: 'provisionalBill',
        meta: { title: '临时账单' },
        component: () => import('../views/payRecord/provisionalBill.vue'),
    },   
    billReview: {
        path: 'billReview',
        name: 'billReview',
        meta: { title: '账单审核' },
        component: () => import('../views/payRecord/billReview.vue'),
    },                  
    // 投诉列表
    complaint: {
        path: 'complaint',
        name: 'complaint',
        meta: { title: '投诉列表' },
        component: () => import('../views/complaint/complaint.vue'),
    },
    complaintClass: {
        path: 'complaintClass',
        name: 'complaintClass',
        meta: { title: '投诉分类' },
        component: () => import('../views/complaint/complaintClass.vue'),
    },
    //评价管理
    evaluate: {
        path: 'evaluate',
        name: 'evaluate',
        meta: { title: '评价列表' },
        component: () => import('../views/evaluate/evaluate.vue'),
    },
    // 报修管理
    warrantyClass: {
        path: 'warrantyClass',
        name: 'warrantyClass',
        meta: { title: '报修分类' },
        component: () => import('../views/warranty/warrantyClass.vue'),
    },
    report: {
        path: 'report',
        name: 'report',
        meta: { title: '报修列表' },
        component: () => import('../views/warranty/report.vue'),
    },
    addWarranty: {
        path: 'addWarranty',
        name: 'addWarranty',
        meta: { title: '添加报修' },
        component: () => import('../views/warranty/addWarranty.vue'),
    },
    unhandled: {
        path: 'unhandled',
        name: 'unhandled',
        meta: { title: '未处理订单' },
        component: () => import('../views/warranty/unhandled.vue'),
    },
    distributed: {
        path: 'distributed',
        name: 'distributed',
        meta: { title: '已分发订单' },
        component: () => import('../views/warranty/distributed.vue'),
    },
    accepted: {
        path: 'accepted',
        name: 'accepted',
        meta: { title: '已受理订单' },
        component: () => import('../views/warranty/accepted.vue'),
    },
    completed: {
        path: 'completed',
        name: 'completed',
        meta: { title: '已完成订单' },
        component: () => import('../views/warranty/completed.vue'),
    },
    rejected: {
        path: 'rejected',
        name: 'rejected',
        meta: { title: '已拒绝订单' },
        component: () => import('../views/warranty/rejected.vue'),
    },
    canceled: {
        path: 'canceled',
        name: 'canceled',
        meta: { title: '已取消订单' },
        component: () => import('../views/warranty/canceled.vue'),
    },
    evaluated: {
        path: 'evaluated',
        name: 'evaluated',
        meta: { title: '已评价订单' },
        component: () => import('../views/warranty/evaluated.vue'),
    },
    allOrder: {
        path: 'allOrder',
        name: 'allOrder',
        meta: { title: '全部订单' },
        component: () => import('../views/warranty/allOrder.vue'),
    },    
    // 报事管理
    matterClass: {
        path: 'matterClass',
        name: 'matterClass',
        meta: { title: '报事分类' },
        component: () => import('../views/matter/matterClass.vue'),
    },
    addMatter: {
        path: 'addMatter',
        name: 'addMatter',
        meta: { title: '添加报修' },
        component: () => import('../views/matter/addMatter.vue'),
    },
    Munhandled: {
        path: 'Munhandled',
        name: 'Munhandled',
        meta: { title: '未处理订单' },
        component: () => import('../views/matter/Munhandled.vue'),
    },
    Mdistributed: {
        path: 'Mdistributed',
        name: 'Mdistributed',
        meta: { title: '已分发订单' },
        component: () => import('../views/matter/Mdistributed.vue'),
    },
    Maccepted: {
        path: 'Maccepted',
        name: 'Maccepted',
        meta: { title: '已受理订单' },
        component: () => import('../views/matter/Maccepted.vue'),
    },
    Mcompleted: {
        path: 'Mcompleted',
        name: 'Mcompleted',
        meta: { title: '已完成订单' },
        component: () => import('../views/matter/Mcompleted.vue'),
    },
    Mrejected: {
        path: 'Mrejected',
        name: 'Mrejected',
        meta: { title: '已拒绝订单' },
        component: () => import('../views/matter/Mrejected.vue'),
    },
    Mcanceled: {
        path: 'Mcanceled',
        name: 'Mcanceled',
        meta: { title: '已取消订单' },
        component: () => import('../views/matter/Mcanceled.vue'),
    },
    Mevaluated: {
        path: 'Mevaluated',
        name: 'Mevaluated',
        meta: { title: '已评价订单' },
        component: () => import('../views/matter/Mevaluated.vue'),
    },
    // 消息管理
    newsList: {
        path: 'newsList',
        name: 'newsList',
        meta: { title: '消息管理' },
        component: () => import('../views/news/newsList.vue'),
    },  
    // banner管理
    banner: {
        path: 'banner',
        name: 'banner',
        meta: { title: 'banner管理' },
        component: () => import('../views/banner/banner.vue'),
    },    
    // 活动管理
    voteList: {
        path: 'voteList',
        name: 'voteList',
        meta: { title: '投票管理' },
        component: () => import('../views/activity/voteList.vue'),
    },  
    questionnaire: {
        path: 'questionnaire',
        name: 'questionnaire',
        meta: { title: '问卷调查' },
        component: () => import('../views/activity/questionnaire.vue'),
    },  
    notice: {
        path: 'notice',
        name: 'notice',
        meta: { title: '公告管理' },
        component: () => import('../views/activity/notice.vue'),
    }, 
    activity: {
        path: 'activity',
        name: 'activity',
        meta: { title: '活动管理' },
        component: () => import('../views/activity/activity.vue'),
    },         
    // 
    personnel: {
        path: 'personnel',
        name: 'personnel',
        meta: { title: '物业人员' },
        component: () => import('../views/personList/personnel.vue'),
    }, 
    vehicle: {
        path: 'vehicle',
        name: 'vehicle',
        meta: { title: '车位管理' },
        component: () => import('../views/personList/vehicle.vue'),
    },     
    // 运维管理  
    navigationList: {
        path: 'navigationList',
        name: 'navigationList',
        meta: { title: '导航管理' },
        component: () => import('../views/maintain/navigationList.vue'),
    },  
    lostArticle: {
        path: 'lostArticle',
        name: 'lostArticle',
        meta: { title: '失物招领' },
        component: () => import('../views/maintain/lostArticle.vue'),
    },  
    field: {
        path: 'field',
        name: 'field',
        meta: { title: '场地预约' },
        component: () => import('../views/maintain/field.vue'),
    },     
    community: {
        path: 'community',
        name: 'community',
        meta: { title: '社区服务' },
        component: () => import('../views/maintain/community.vue'),
    },           
    oldCare: {
        path: 'oldCare',
        name: 'oldCare',
        meta: { title: '老人关怀' },
        component: () => import('../views/maintain/oldCare.vue'),
    },   
    doorTodoor: {
        path: 'doorTodoor',
        name: 'doorTodoor',
        meta: { title: '到户服务' },
        component: () => import('../views/maintain/doorTodoor.vue'),
    },    
    volunteer: {
        path: 'volunteer',
        name: 'volunteer',
        meta: { title: '志愿者招募' },
        component: () => import('../views/maintain/volunteer.vue'),
    },              
    // 扫码巡更
    nightPatrolClass: {
        path: 'nightPatrolClass',
        name: 'nightPatrolClass',
        meta: { title: '巡更点管理' },
        component: () => import('../views/nightPatrol/nightPatrolClass.vue'),
    },    
    nightPatrolList: {
        path: 'nightPatrolList',
        name: 'nightPatrolList',
        meta: { title: '巡更列表' },
        component: () => import('../views/nightPatrol/nightPatrolList.vue'),
    },  
    nightPatrolRecord: {
        path: 'nightPatrolRecord',
        name: 'nightPatrolRecord',
        meta: { title: '巡更记录' },
        component: () => import('../views/nightPatrol/nightPatrolRecord.vue'),
    }, 
    // 置换平台
    substitution: {
        path: 'substitution',
        name: 'substitution',
        meta: { title: '置换平台' },
        component: () => import('../views/substitution/substitution.vue'),
    }, 
    // 置换平台
    substitutionClass: {
        path: 'substitutionClass',
        name: 'substitutionClass',
        meta: { title: '分类列表' },
        component: () => import('../views/substitution/substitutionClass.vue'),
    },   
    // 置换平台
    substitutionExamine: {
        path: 'substitutionExamine',
        name: 'substitutionExamine',
        meta: { title: '审核列表' },
        component: () => import('../views/substitution/substitutionExamine.vue'),
    },       
    // 浙里办-工单管理
    zlbOrderWork: {
        path: 'zlbOrderWork',
        name: 'zlbOrderWork',
        meta: { title: '工单管理' },
        component: () => import('../views/zlb/zlbOrderWork.vue'),
    },   
    // 浙里办-建议咨询管理
    zlbProposal: {
        path: 'zlbProposal',
        name: 'zlbProposal',
        meta: { title: '建议咨询管理' },
        component: () => import('../views/zlb/zlbProposal.vue'),
    },   
    // 浙里办-建议咨询管理
    zlbVisitorList: {
        path: 'zlbVisitorList',
        name: 'zlbVisitorList',
        meta: { title: '访客列表' },
        component: () => import('../views/zlb/zlbVisitorList.vue'),
    },     
    // 养老食堂
    canteenClass: {
        path: 'canteenClass',
        name: 'canteenClass',
        meta: { title: '分类列表' },
        component: () => import('../views/canteen/canteenClass.vue'),
    },    
    canteenList: {
        path: 'canteenList',
        name: 'canteenList',
        meta: { title: '商品列表' },
        component: () => import('../views/canteen/canteenList.vue'),
    }, 
    canteenOrder: {
        path: 'canteenOrder',
        name: 'canteenOrder',
        meta: { title: '订单列表' },
        component: () => import('../views/canteen/canteenOrder.vue'),
    },   
    // 工单管理
    distribute: {
        path: 'distribute',
        name: 'distribute',
        meta: { title: '工单派单' },
        component: () => import('../views/workOrder/distribute.vue'),
    },  
    distributeClass: {
        path: 'distributeClass',
        name: 'distributeClass',
        meta: { title: '派单类型' },
        component: () => import('../views/workOrder/distributeClass.vue'),
    },      
    distributeRecord: {
        path: 'distributeRecord',
        name: 'distributeRecord',
        meta: { title: '派单记录' },
        component: () => import('../views/workOrder/distributeRecord.vue'),
    },        
    singlePage: {
        path: 'singlePage',
        name: 'singlePage',
        meta: { title: '单页面管理' },
        component: () => import('../views/singlePage/index.vue'),
    },      
    //积分商城  
    integralShop: {
        path: 'integralShop',
        name: 'integralShop',
        meta: { title: '兑换商城商品列表' },
        component: () => import('../views/integralShop/index.vue'),
    },     
    shopOrder: {
        path: 'shopOrder',
        name: 'shopOrder',
        meta: { title: '兑换列表' },
        component: () => import('../views/integralShop/shopOrder.vue'),
    }, 
    //活动发起
    proposal: {
        path: 'proposal',
        name: 'proposal',
        meta: { title: '活动提案' },
        component: () => import('../views/initiation/proposal.vue'),
    },
    proposalType: {
        path: 'proposalType',
        name: 'proposalType',
        meta: { title: '主题类型列表' },
        component: () => import('../views/initiation/type.vue'),
    },
    discuss: {
        path: 'discuss',
        name: 'discuss',
        meta: { title: '共议发起' },
        component: () => import('../views/initiation/discuss.vue'),
    },
    record: {
        path: 'record',
        name: 'record',
        meta: { title: '已缴费列表' },
        component: () => import('../views/bill/record.vue'),
    },
    recordNo: {
        path: 'recordNo',
        name: 'recordNo',
        meta: { title: '未缴费列表' },
        component: () => import('../views/bill/recordNo.vue'),
    },
    price: {
        path: 'price',
        name: 'price',
        meta: { title: '维修价目列表' },
        component: () => import('../views/warranty/price.vue'),
    },
}
const createRouter = () => new Router({
    routes: commonRoutes,
})

const router = createRouter()

export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher
}

export default router